import { defineRouting } from "next-intl/routing";

export const LOCALE_COOKIE = "kessem-locale";
export const CURRENCY_COOKIE = "kessem-currency";

export const routing = defineRouting({
  locales: ["fr", "he", "en"],
  defaultLocale: "fr",
  localePrefix: "always",
  localeDetection: false,
  localeCookie: { name: LOCALE_COOKIE, maxAge: 60 * 60 * 24 * 365 },
});

export type Locale = (typeof routing.locales)[number];

export const localeMeta: Record<
  Locale,
  { label: string; nativeLabel: string; flag: string; dir: "ltr" | "rtl" }
> = {
  fr: { label: "French", nativeLabel: "Français", flag: "🇫🇷", dir: "ltr" },
  he: { label: "Hebrew", nativeLabel: "עברית", flag: "🇮🇱", dir: "rtl" },
  en: { label: "English", nativeLabel: "English", flag: "🇬🇧", dir: "ltr" },
};

export function getDirection(locale: Locale): "ltr" | "rtl" {
  return localeMeta[locale].dir;
}
